import styled from 'styled-components';
import { ColumnFlexContainer } from '../../../../../../stories/atoms/containerV2/ContainerV2';

export const FlexContainer = styled(ColumnFlexContainer)`
  & :last-child {
    border-bottom: none;
  }
`;

export const TillWrapper = styled(ColumnFlexContainer)<{ isOpen: boolean }>`
  border-bottom: 1px solid
    ${({ theme }) => (theme.palette.mode === 'dark' ? theme.color.borderGrayDark : theme.color.borderGray)};
  background-color: ${({ isOpen, theme: { color, palette } }) =>
    isOpen && (palette.mode === 'dark' ? color.backgroundSelectedHover : color.baseGray)};

  &:hover {
    background-color: ${({ isOpen, theme: { color, palette } }) =>
      isOpen ? 'none' : palette.mode === 'dark' ? color.backgroundSelectedDark : color.backgroundSelectedDark};
  }
  &:first-of-type {
    border-top-left-radius: ${({ theme: { spacing } }) => spacing(4)};
    border-top-right-radius: ${({ theme: { spacing } }) => spacing(4)};
  }
  &:last-child {
    border-bottom-left-radius: ${({ theme: { spacing } }) => spacing(4)};
    border-bottom-right-radius: ${({ theme: { spacing } }) => spacing(4)};
  }
`;
